import React from 'react';
import activity, { Activity } from './modules/activity';
import activityContract, { ActivityContract } from './modules/activityContract';
import activitySupplier, { ActivitySupplier } from './modules/activitySupplier';
import allotment, { Allotment } from './modules/allotment';
import auth, { Auth } from './modules/auth';
import backend, { Backend } from './modules/backend';
import bookingDetail, { BookingDetail } from './modules/bookingDetail';
import contract, { Contract } from './modules/contract';
import inventory, { Inventory } from './modules/inventory';
import memo, { Memo } from './modules/memo';
import ota, { Ota } from './modules/ota';
import plan, { Plan } from './modules/plan';
import supplier, { Supplier } from './modules/supplier';
import timeZone, { TimeZone } from './modules/timeZone';

export type RootStore = {
  auth: Auth;
  contract: Contract;
  supplier: Supplier;
  memo: Memo;
  activity: Activity;
  plan: Plan;
  activitySupplier: ActivitySupplier;
  timeZone: TimeZone;
  ota: Ota;
  activityContract: ActivityContract;
  backend: Backend;
  inventory: Inventory;
  allotment: Allotment;
  bookingDetail: BookingDetail;
};

export const store: RootStore = {
  auth,
  contract,
  supplier,
  memo,
  activity,
  plan,
  activitySupplier,
  timeZone,
  ota,
  activityContract,
  backend,
  inventory,
  allotment,
  bookingDetail
};

const StoreContext = React.createContext<RootStore>(store);

export const StoreProvider = StoreContext.Provider;

export const useStore = () => React.useContext(StoreContext);

export { auth, contract, activity, supplier };
